/* global document */
import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { DateTime } from 'luxon';
import StackedToasts from '../StackedToasts';
import { nanoid } from 'nanoid';

export const ToastContext = createContext({});

const createPortalSSR = (children, containerId) => {
    const [container, setContainer] = useState(null);
    useEffect(() => {
        setContainer(typeof window !== 'undefined'
            ? document.getElementById(containerId)
            : null);
    }, []);
    if (container === null)
        return null;
    return createPortal(
        children,
        container,
    );
};

// The app context provider component
const ToastContextProvider = ({ children }) => {
    // defaultToastContext is returned by the server on the initial render
    const [messages, setMessages] = useState([]);
    const sendMessage = useCallback((text = '', bg = 'light') => {
        const isoDate = DateTime.now().toISO();
        setMessages([...messages, {
            id: nanoid(),
            text,
            isoTime: isoDate,
            bg,
        }]);
    }, [messages]);
    const contextValue = useMemo(() => ({
        sendMessage,
    }), [sendMessage]);
    return (<ToastContext.Provider
        value={contextValue}>
        {createPortalSSR(
            <StackedToasts
                setMessages={setMessages}
                messages={messages}></StackedToasts>,
            'notif-toast',
        )}
        {children}
    </ToastContext.Provider>);
};

ToastContextProvider.propTypes = {
    children: PropTypes.node,
};

export default ToastContextProvider;